import React, { useState } from 'react';
import { Button , Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

import GuideFiltersGroup from './GuideFiltersGroup';
 
export default function GuideFilterButton() {
  const [modal, setModal] = useState(false);
  const openModal = () => setModal(true);
  const closeModal = () => setModal(false);
  const toggleModal = () => setModal(!modal);
  return <>
    <Button color="yellow" onClick={openModal} size="small">Filters</Button>
    <Modal isOpen={modal} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Filters</ModalHeader>
      <ModalBody>
        <GuideFiltersGroup/>
      </ModalBody>
      <ModalFooter>
        <Button color="yellow" onClick={closeModal}>See Results</Button>
      </ModalFooter>
    </Modal>
  </>
};
